function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import toolCom from '../mobileConfigRight/index.js';
import rightBtn from '../rightBtn/index.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'c_home_seckill',
  componentsName: 'home_seckill',
  components: _objectSpread(_objectSpread({}, toolCom), {}, {
    rightBtn: rightBtn
  }),
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  data: function data() {
    return {
      configObj: {},
      rCom: [{
        components: toolCom.c_checked_tab,
        configNme: 'setUp'
      }]
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = value;
    },
    configObj: {
      handler: function handler(nVal, oVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.setUp.tabVal': {
      handler: function handler(nVal, oVal) {
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          var tempArr = [{
            components: toolCom.c_title,
            configNme: 'tabConfig'
          }, {
            components: toolCom.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'logoConfig'
          }, {
            components: toolCom.c_upload_img,
            configNme: 'logoConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'titleConfig'
          }, {
            components: toolCom.c_input_item,
            configNme: 'titleConfig'
          }, {
            components: toolCom.c_input_item,
            configNme: 'linkConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'typeConfig'
          }, {
            components: toolCom.c_checkbox_group,
            configNme: 'typeConfig'
          }];
          this.rCom = arr.concat(tempArr);
        } else {
          var _tempArr = [{
            components: toolCom.c_title,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'titleColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'moreColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'nameColor'
          }, {
            components: toolCom.c_radio,
            configNme: 'themeStyleConfig'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'priceColor'
          }, {
            components: toolCom.c_title,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'downConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'lrConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'contentConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'mbConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'contentStyle'
          }];
          this.rCom = arr.concat(_tempArr);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = value;
    });
  },
  created: function created() {},
  methods: {
    getConfig: function getConfig(data) {
      if (data.name && data.name === 'c_input_item') this.configObj.linkConfig.val = data.values;
    }
  }
};